import { supportedRegionTimezonesForInCharge } from './incharge-supported-regions';
interface Window {
	dismissInChargeAppBanner: () => void;
	openPlayStore: () => void;
}
declare let window: Window;

/* Start of global functions */
window.dismissInChargeAppBanner = () => {
	// Hide banner for 30 days
	global.window.localStorage.setItem(LOCAL_STORAGE_INSTALL_BANNER_DISMISSED, EXPIRATION_TIME.toString());
	document.getElementById('in-charge-install-banner')?.classList.remove('show-banner');
	document.getElementById('in-charge-install-banner')?.classList.add('hide-banner');
};

window.openPlayStore = () => {
	global.window.location.href =
		'https://play.google.com/store/apps/details?id=com.shift4.skytab.incharge&utm_source=LBM&utm_medium=banner&utm_campaign=InCharge';
};
/* End of global functions */

const LOCAL_STORAGE_INSTALL_BANNER_DISMISSED = 's4-installBannerDismissedUntil';
const EXPIRATION_TIME = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;

// using timezone value, checks that if the region(country) has InCharge app available or not
const isSupportedRegionForInChargeApp = () => {
	const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

	if (timezone === '' || !timezone) {
		return false;
	}
	return (
		timezone in supportedRegionTimezonesForInCharge &&
		['CA', 'US'].some((countryCode) => supportedRegionTimezonesForInCharge[timezone].countryCode.includes(countryCode))
	);
};

const shouldShowInChargeBanner = () => {
	// if user agent is not android or if region is unsupported, do not show banner
	if (!/android/i.test(navigator.userAgent) || !isSupportedRegionForInChargeApp()) {
		return false;
	}

	// Check if the banner was dismissed in the last 30 days
	const dismissedUntil = localStorage.getItem(LOCAL_STORAGE_INSTALL_BANNER_DISMISSED);
	const now = new Date().getTime();

	if (!dismissedUntil || now > parseInt(dismissedUntil, 10)) {
		return true;
	}
	return false;
};

export const showAndroidInChargePrompt = () => {
	if (!shouldShowInChargeBanner()) {
		return;
	}
	setTimeout(() => {
		document.getElementById('in-charge-install-banner')?.classList.remove('hide-banner');
		document.getElementById('in-charge-install-banner')?.classList.add('show-banner');
	}, 1000);
};
